export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          <div>
            <img 
              alt="Abu Ayaan Services" 
              className="h-12 mb-4 brightness-0 invert" 
              src="https://static.readdy.ai/image/f5502c8213cacad10181856e9050c60c/ed731c15cb79f79d6f6f2b2cd62b80e9.png"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Professional cleaning and contracting services in Bahrain. Trusted by ministries, factories, malls, and hospitals.
            </p>
          </div>
          
          <div>
            <h4 className="text-sm font-semibold uppercase text-gray-400 mb-6 tracking-wider">
              QUICK CONTACT
            </h4>
            <div className="space-y-4">
              <a 
                href="tel:+97336096336" 
                className="flex items-center gap-3 text-white hover:text-teal-400 transition-colors text-sm cursor-pointer"
              >
                <i className="ri-phone-line"></i>
                <span>+973 36096336</span>
              </a>
              <div className="flex items-center gap-3 text-white text-sm">
                <i className="ri-map-pin-line"></i>
                <span>Block: 404, Sanabis, Kingdom of Bahrain</span>
              </div>
            </div>
          </div>
          
          <div>
            <h4 className="text-sm font-semibold uppercase text-gray-400 mb-6 tracking-wider">
              SERVICES
            </h4>
            <ul className="space-y-4">
              <li>
                <a href="#services" className="text-gray-300 hover:text-white transition-colors text-sm">
                  General Cleaning
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Deep Cleaning
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Pest Control
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Office Services
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Specialized Cleaning
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-sm font-semibold uppercase text-gray-400 mb-6 tracking-wider">
              FOLLOW US
            </h4>
            <ul className="space-y-4">
              <li>
                <a 
                  href="https://wa.me/97336096336" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-gray-300 hover:text-white transition-colors flex items-center gap-2 text-sm cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-lg"></i>
                  WhatsApp
                </a>
              </li>
              <li>
                <a 
                  href="#" 
                  className="text-gray-300 hover:text-white transition-colors flex items-center gap-2 text-sm cursor-pointer"
                >
                  <i className="ri-facebook-line text-lg"></i>
                  Facebook
                </a>
              </li>
              <li>
                <a 
                  href="#" 
                  className="text-gray-300 hover:text-white transition-colors flex items-center gap-2 text-sm cursor-pointer"
                >
                  <i className="ri-instagram-line text-lg"></i>
                  Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-12">
          <div className="text-center mb-8">
            <h2 className="text-7xl font-bold text-amber-100/20 tracking-tight">
              ABU AYAAN SERVICES WLL
            </h2>
          </div>
          
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <p>© 2025 Abu Ayaan Services. All rights reserved.</p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="hover:text-white transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
